var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContentCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.16481 11.7703C4.75803 11.7703 4.41372 11.6342 4.13189 11.3619C3.85004 11.0895 3.70911 10.7568 3.70911 10.3638V1.50566C3.70911 1.11263 3.85004 0.779945 4.13189 0.507615C4.41372 0.235286 4.75803 0.0991211 5.16481 0.0991211H11.9168C12.3236 0.0991211 12.6679 0.235286 12.9497 0.507615C13.2316 0.779945 13.3725 1.11263 13.3725 1.50566V10.3638C13.3725 10.7568 13.2316 11.0895 12.9497 11.3619C12.6679 11.6342 12.3236 11.7703 11.9168 11.7703H5.16481ZM5.16481 10.6032H11.9168C11.9787 10.6032 12.0355 10.5783 12.0872 10.5284C12.1388 10.4785 12.1646 10.4237 12.1646 10.3638V1.50566C12.1646 1.4458 12.1388 1.39093 12.0872 1.34104C12.0355 1.29117 11.9787 1.26623 11.9168 1.26623H5.16481C5.10285 1.26623 5.04607 1.29117 4.99445 1.34104C4.94282 1.39093 4.917 1.4458 4.917 1.50566V10.3638C4.917 10.4237 4.94282 10.4785 4.99445 10.5284C5.04607 10.5783 5.10285 10.6032 5.16481 10.6032ZM2.34632 14.4936C1.93956 14.4936 1.59525 14.3574 1.3134 14.0851C1.03155 13.8128 0.890625 13.4801 0.890625 13.0871V3.06183H2.09854V13.0871C2.09854 13.1469 2.12435 13.2018 2.17596 13.2517C2.2276 13.3016 2.28438 13.3265 2.34632 13.3265H10.3062V14.4936H2.34632Z",
    fill: "#e33745"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentCopy);
export default __webpack_public_path__ + "static/media/content_copy.95a996dce96636b186aad49244431ef3.svg";
export { ForwardRef as ReactComponent };